import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
// Chakra imports
import {
  Button,
  Flex,
  Grid,
  Text,
  FormControl,
  FormLabel,
  Input,
  Switch,
  Select,
  useToast,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Tooltip,
  Divider,
} from "@chakra-ui/react";

// Images

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";

// Data
import { useLoader } from "components/Loader/loader";
import useApiReq from "variables/apireq";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ChakraStyledSelect from "components/CustomField/ChakraStyledSelect";

const costing = {
  pr: 10000,
  analytics: 20000,
};

function OrderCreate() {
  const titleColor = "white";

  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [sliderValue, setSliderValue] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const [advertiserList, setAdvertiserList] = useState([]);
  const location = useLocation();

  const [estimatedReader, setEstimatedReader] = useState(0);
  const [uniqueReach, setUniqueReach] = useState(0);
  const searchParams = new URLSearchParams(location.search);
  const [cost, setCost] = useState(0);
  const toast = useToast({ position: "top" });
  const history = useHistory();

  const { setIsLoading, isLoading } = useLoader();

  useEffect(() => {
    if (localStorage.getItem("group") === "Publisher") {
      fetchAdvertiser();
    }
  }, []);

  const [formData, setFormData] = useState({
    advertiser: "",
    prNumber: 0,
    analytics: false,
    socialMedia: false,
    package: "",
    prType: "",
  });

  const createOrder = async (data) => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "POST",
        url: "order/add/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data,
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setError(null);
        toast({
          title: "Success",
          description: "Order created successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setFormData({
          advertiser: "",
          prNumber: 0,
          analytics: false,
          socialMedia: false,
          package: "",
          prType: "",
        });
        setEstimatedReader(0);
        setUniqueReach(0);
        setCost(0);
        if (localStorage.getItem("group") === "Publisher") {
          setFormData((prev) => ({
            ...prev,
            advertiser: "",
          }));
        }
        history.push(
          `/${localStorage.getItem("group").toLowerCase()}/order/list`
        );
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAdvertiser = async () => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "advertiser/list/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setAdvertiserList(res.response);
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("group") === "Publisher") {
      setFormData((prev) => ({
        ...prev,
        advertiser: "",
      }));
    }
  }, []);

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  //   if (name === "partial" && !checked) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       partialAmount: "",
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => {
      let updatedForm = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      // If analytics is checked, auto-check socialMedia
      if (name === "analytics" && checked) {
        updatedForm.socialMedia = true;
      }

      // If partial is unchecked, reset partialAmount
      if (name === "partial" && !checked) {
        updatedForm.partialAmount = "";
      }

      return updatedForm;
    });
  };

  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.prNumber === 0) {
      toast({
        title: "Error",
        description: "Please select a PR number",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const data = {
      prnumber: formData.prNumber,
      analytics: false,
      facebook: false,
      price: cost,
      estimated_reader: uniqueReach,
      type: formData.prType,
      package_name: formData.package,
    };

    if (localStorage.getItem("group") === "Publisher") {
      if (formData.advertiser === "") {
        toast({
          title: "Error",
          description: "Please select an advertiser",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      data.advertiser_uuid = formData.advertiser;
    }
    createOrder(data);
  };

  useEffect(() => {
    var total = formData.prNumber * costing.pr;

    if (formData.prType === "Online") {
      total = total * 1;
    } else if (formData.prType === "Print") {
      total = total * 2;
    }

    if (formData.prType === "Online&Analytic") {
      var totalreader = formData.prNumber * 30000;
      setUniqueReach(totalreader / formData.prNumber);
      total += costing.analytics * formData.prNumber;
    }
    setEstimatedReader(totalreader);
    setCost(total);
  }, [formData]);

  useEffect(() => {
    if (formData.prNumber === 0) {
      setFormData((prev) => ({
        ...prev,
        analytics: false,
        socialMedia: false,
        prNumber: 0,
      }));
    }
  }, [formData.prNumber]);
  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
      <Grid templateColumns={{ sm: "1fr", lg: "60% 38%" }}>
        {/* Form */}
        <Card p="16px">
          <CardHeader>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                Order Create
              </Text>
            </Flex>
          </CardHeader>
          <CardBody>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <GradientBorder
                p="2px"
                ml={{ base: "0px", lg: "24px" }}
                w="100%"
                me={{ base: "none", lg: "30px", xl: "none" }}
                background="transparent"
                boxShadow="0px 0px 2px 2px rgba(255,255,255,0.1)"
                borderRadius="30px"
              >
                <Flex
                  background="transparent"
                  borderRadius="30px"
                  direction="column"
                  p="40px"
                  minW={{ base: "unset", md: "430px", xl: "450px" }}
                  w="100%"
                  mx={{ base: "0px" }}
                  bg={{
                    base: "rgba(19,21,56,.5)",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <FormControl>
                      {localStorage.getItem("group") === "Publisher" && (
                        <>
                          <FormLabel
                            color={titleColor}
                            ms="4px"
                            fontSize="sm"
                            fontWeight="normal"
                          >
                            Select Advertiser
                          </FormLabel>
                          <GradientBorder
                            mb="24px"
                            h="50px"
                            w={{ base: "100%", lg: "100%" }}
                            borderRadius="20px"
                          >
                            <Select
                              color={titleColor}
                              bg={{
                                base: "rgb(19,21,54)",
                              }}
                              border="transparent"
                              borderRadius="20px"
                              fontSize="sm"
                              size="lg"
                              w={{ base: "100%", lg: "100%" }}
                              maxW="100%"
                              h="46px"
                              type="text"
                              placeholder="Select Advertiser"
                              name="advertiser"
                              value={formData.advertiser}
                              onChange={handleChange}
                              sx={{
                                option: {
                                  backgroundColor: "rgb(19,21,54)",
                                  color: "white",
                                },
                              }}
                            >
                              {advertiserList?.map((item) => (
                                <option key={item.uuid} value={item.uuid}>
                                  {item.user.username}
                                </option>
                              ))}
                            </Select>
                          </GradientBorder>
                        </>
                      )}

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        PR Type
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          required={false}
                          type="text"
                          placeholder="Select PR Type"
                          name="prType"
                          value={formData.prType}
                          onChange={handleChange}
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                        >
                          <option value="Online">Online</option>
                          <option value="Print">Print</option>
                          <option value="Online&Analytic">
                            Online&Analytic
                          </option>
                        </Select>
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Select Package
                      </FormLabel>

                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type="text"
                          placeholder="Select Package"
                          name="package"
                          value={formData.package}
                          onChange={handleChange}
                        />
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        No of PR
                      </FormLabel>
                      <Flex
                        gap={4}
                        align="center"
                        justify={"center"}
                        w="100%"
                        mb="20px"
                      >
                        <Slider
                          id="slider"
                          defaultValue={0}
                          value={sliderValue}
                          min={0}
                          max={20}
                          w={{ base: "70%" }}
                          colorScheme="teal"
                          onChange={(v) => {
                            setSliderValue(v);
                            setFormData((prev) => ({
                              ...prev,
                              prNumber: v,
                            }));
                          }}
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                        >
                          <SliderTrack>
                            <SliderFilledTrack />
                          </SliderTrack>
                          <Tooltip
                            hasArrow
                            bg="teal.500"
                            color="white"
                            placement="top"
                            isOpen={showTooltip}
                            label={`${sliderValue}`}
                          >
                            <SliderThumb />
                          </Tooltip>
                        </Slider>
                        <GradientBorder
                          h="50px"
                          w={{ base: "20%" }}
                          borderRadius="20px"
                        >
                          <Input
                            color={titleColor}
                            bg={{
                              base: "rgb(19,21,54)",
                            }}
                            border="transparent"
                            borderRadius="20px"
                            size="sm"
                            w={{ base: "100%" }}
                            maxW="100%"
                            textAlign={"center"}
                            fontSize="lg"
                            h="46px"
                            type="text"
                            placeholder="PR"
                            name="prNumber"
                            isInvalid={formData.prNumber > 20}
                            value={formData.prNumber}
                            onChange={handleChange}
                            onMouseLeave={() => {
                              if (formData.prNumber <= 20) {
                                setSliderValue(formData.prNumber);
                              }
                            }}
                          />
                        </GradientBorder>
                      </Flex>
                      <Flex
                        justify="space-between"
                        align="center"
                        style={{
                          display: "none",
                        }}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Analytics
                        </FormLabel>
                        <Flex
                          justify="space-between"
                          align="center"
                          w="auto"
                          mb="20px"
                          gap={4}
                        >
                          <Switch
                            colorScheme="teal"
                            size="lg"
                            name="analytics"
                            onChange={handleChange}
                            disabled={formData.prNumber > 0 ? false : true}
                            isChecked={formData.analytics}
                          />
                        </Flex>
                      </Flex>
                      <Flex
                        justify="space-between"
                        align="center"
                        style={{
                          display: "none",
                        }}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Social Media
                        </FormLabel>
                        <Flex
                          justify="space-between"
                          align="center"
                          w="auto"
                          mb="20px"
                          gap={4}
                        >
                          <Switch
                            colorScheme="teal"
                            size="lg"
                            name="socialMedia"
                            isChecked={formData.socialMedia}
                            variant={"outline"}
                            onChange={handleChange}
                            disabled={formData.prNumber > 0 ? false : true}
                          />
                        </Flex>
                      </Flex>

                      <motion.div
                        initial={{
                          height: cost > 0 ? 0 : 1,
                          opacity: cost > 0 ? 0 : 1,
                        }}
                        animate={{
                          height: cost > 0 ? "auto" : 0,
                          opacity: cost > 0 ? 1 : 0,
                        }}
                        transition={{ duration: 0.3 }}
                        hidden={cost <= 0}
                      >
                        <Flex direction={"column"} align="center" w="100%">
                          <Divider />
                          <Flex
                            justify="space-between"
                            align="center"
                            w="100%"
                            mt="20px"
                          >
                            <FormLabel
                              color={titleColor}
                              ms="4px"
                              fontSize="sm"
                              fontWeight="normal"
                            >
                              Total Amount
                            </FormLabel>
                            <Flex
                              justify="space-between"
                              align="center"
                              w={{ base: "auto" }}
                            >
                              <Text
                                color={titleColor}
                                fontSize="lg"
                                fontWeight="500"
                              >
                                {cost} BDT
                              </Text>
                            </Flex>
                          </Flex>
                          {formData.prType === "Online&Analytic" ? (
                            <Flex
                              justify="space-between"
                              align="center"
                              w="100%"
                              mt="20px"
                            >
                              <FormLabel
                                color={titleColor}
                                ms="4px"
                                fontSize="sm"
                                fontWeight="normal"
                              >
                                Unique Reach Per PR
                              </FormLabel>
                              <Flex
                                justify="space-between"
                                align="center"
                                w={{ base: "auto" }}
                              >
                                <Text
                                  color={titleColor}
                                  fontSize="lg"
                                  fontWeight="500"
                                >
                                  {uniqueReach}
                                </Text>
                              </Flex>
                            </Flex>
                          ) : null}
                          {formData.prType === "Online&Analytic" ? (
                            <Flex
                              justify="space-between"
                              align="center"
                              w="100%"
                              mt="20px"
                            >
                              <FormLabel
                                color={titleColor}
                                ms="4px"
                                fontSize="sm"
                                fontWeight="normal"
                              >
                                Qumulative Reach
                              </FormLabel>
                              <Flex
                                justify="space-between"
                                align="center"
                                w={{ base: "auto" }}
                              >
                                <Text
                                  color={titleColor}
                                  fontSize="lg"
                                  fontWeight="500"
                                >
                                  {estimatedReader}
                                </Text>
                              </Flex>
                            </Flex>
                          ) : null}
                        </Flex>
                      </motion.div>

                      <Button
                        variant="brand"
                        fontSize="1.2rem"
                        type="submit"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="45px"
                        mb="20px"
                        mt="20px"
                        disabled={formData.prNumber === 0}
                      >
                        Submit
                      </Button>
                    </FormControl>
                  </form>
                </Flex>
              </GradientBorder>
            </Flex>
          </CardBody>
        </Card>

        {/* Preview */}
        <Card
          p="22px"
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}
        >
          <Flex direction="column">
            <CardHeader py="16px">
              <Text color="#fff" fontSize="lg" fontWeight="bold">
                Preview
              </Text>
            </CardHeader>
            <CardBody>
              <Flex direction="column" w="100%">
                {Object.entries(formData).map(([key, value]) =>
                  value ? (
                    <Text
                      key={key}
                      color="#fff"
                      fontSize="lg"
                      fontWeight="500"
                      style={{
                        textTransform: "capitalize",
                        marginBottom: "10px",
                      }}
                    >
                      {key.replace(/([A-Z])/g, " $1")}:{" "}
                      {typeof value === "boolean"
                        ? value
                          ? "Yes"
                          : "No"
                        : key === "advertiser"
                        ? advertiserList.find((item) => item.uuid === value)
                            .user.username
                        : value}
                    </Text>
                  ) : null
                )}
                {cost > 0 && (
                  <Flex direction="column" w="100%" mt="20px">
                    <Divider />
                    <Flex
                      justify="space-between"
                      align="center"
                      w="100%"
                      mt="20px"
                    >
                      <Text color="#fff" fontSize="lg" fontWeight="500">
                        Total Amount
                      </Text>
                      <Text color="#fff" fontSize="lg" fontWeight="500">
                        {cost} BDT
                      </Text>
                    </Flex>
                    {formData.prType === "Online&Analytic" ? (
                      <Flex
                        justify="space-between"
                        align="center"
                        w="100%"
                        mt="20px"
                      >
                        <Text color="#fff" fontSize="lg" fontWeight="500">
                          Unique Reach Per PR
                        </Text>
                        <Text color="#fff" fontSize="lg" fontWeight="500">
                          {uniqueReach}
                        </Text>
                      </Flex>
                    ) : null}
                    {formData.prType === "Online&Analytic" ? (
                      <Flex
                        justify="space-between"
                        align="center"
                        w="100%"
                        mt="20px"
                      >
                        <Text color="#fff" fontSize="lg" fontWeight="500">
                          Cumulative Reach
                        </Text>
                        <Text color="#fff" fontSize="lg" fontWeight="500">
                          {estimatedReader}
                        </Text>
                      </Flex>
                    ) : null}
                  </Flex>
                )}
              </Flex>
            </CardBody>
          </Flex>
        </Card>
      </Grid>
    </Flex>
  );
}

export default OrderCreate;
